module.exports = __webpack_public_path__ + "static/media/user-1.0ac5dfe4.png";